export default {
    title: 'Model Browser',
    categoriesLabel: 'Categories',
    sortByLabel: 'Sort By',
    modelsLabel: 'Models',
    searchPlaceholder: 'Search keywords',
    videoAvatars: 'Video Avatars',
    sort: {
        camScore: 'Cam Score',
        answer: 'Answer',
        username: 'Username',
        random: 'Random',
        camScoreAsc: 'Cam Score (Ascending)',
        answerReverse: 'Answer (Reverse)',
        usernameZA: 'Username (Z-A)',
    },
    selection: {
        online: 'All Online Models',
        friends: 'Friends',
        oneWeek: 'New To Within 1 Week',
        oneMonth: 'New To Within 1 Month',
    },
    noResults: 'No models found matching your criteria',
    videoAvatarsNoResults:
        'There are no models with a video avatar right now. Try another category.',
    chat: 'Chat',
    offline: 'Offline',
    viewProfile: 'View Profile',
}
